var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{attrs:{"label":"Divided Card","allowClickOnMobile":_vm.allowClickOnMobile},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticStyle:{"color":"#000"},style:({ fontSize: _vm.size })},on),[_vm._v(_vm._s(_vm.icon))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }